import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import stylesParent from '../../styles/frame/frame.module.scss';
import DotIcon from '../../../../../../assets/images/tokens/dot.svg';
import Header from '../../../../../../components/Stake/header';
import { showModal } from '../../../../../../actions/modal-actions';
import {
  getAllAddresses,
  changeChainMode,
} from '../../../../../../actions/account-polkadot-actions';
// import { registerAddress as signEthereumAddressWithDotAddress } from '../../../../../../actions/delegator-reward-actions';
import PolkadotJsIcon from '../../../../../../assets/images/polkadotJs.svg';
import { POLKADOT_LOGIN_MODAL } from '../../../../../../constants/modal-constants';
import { DOT, CHAIN_NAMES } from '../../../../../../constants/blockchain-constants';
import stylesConnect from '../../styles/connect/connect.module.scss';

const Connect = () => {
  const dispatch = useDispatch();
  const dark = useSelector((state) => state.basic.dark);

  return (
    <>
      <Header icon={DotIcon} title={`${DOT}-Nomination`} />
      <div className={stylesConnect.icon}>
        <img src={PolkadotJsIcon} alt='Polkadot JS extention wallet icon' />
      </div>
      <div
        className={cn(
          stylesParent.cardFooterControls,
          stylesParent.withBackground,
          stylesParent.lg,
          {
            [stylesParent.dark]: dark,
          },
        )}
      >
        <Button
          onClick={async () => {
            // Sets the polkadot connect ready to connect polkadot address
            await dispatch(changeChainMode('POLKADOT_AUTH_MODE'));
            await dispatch(getAllAddresses(CHAIN_NAMES.POLKADOT));
            dispatch(showModal(POLKADOT_LOGIN_MODAL));
          }}
          variant='contained'
          color='secondary'
          className={stylesParent.cardFooterControlsButton}
        >
          Connect Polkadot.js wallet
        </Button>
      </div>
      {/* { Register(dispatch) } */}
    </>
  );
};

export default Connect;
